import React from "react";
import { NavLink } from "react-router-dom";
import './CardBox.scss';

export default class CardBox extends React.PureComponent<{ title: string, imageSource: string, redirectLink: string }, {}>{
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): React.ReactNode {
        let { title, imageSource, redirectLink } = this.props;
        return <>
            <NavLink to={redirectLink}>
                <div className="card-box-area">
                    <img src={imageSource} alt="card box icon"></img>
                    <label className="title"> {title}</label>
                </div>
            </NavLink>
        </>
    }


}